import { getAccessTokenFromLocalStorage } from '../utils/authHelpers';
import handleFetchErrors from '../utils/handleFetchErrors';

const search360BaseUrl = process.env.REACT_APP_SEARCH360_HOST;

export function explainSearch() {
  return async ({ queryKey }: { queryKey: string[] }) => {
    const [uri, body] = queryKey;
    const url = `${search360BaseUrl}${uri}`;
    return fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getAccessTokenFromLocalStorage()}`,
        'Content-Type': 'application/json',
      },
      body,
    })
      .then(handleFetchErrors)
      .then((res) => res.json())
      .catch((error) => {
        console.error('Error occurred while fetching:', error);
        throw error; // re-throw the error if you want it to propagate
      });
  };
}
